import React from 'react';

const replaceAll = (line, replace) => {
    const regexPattern = new RegExp(Object.keys(replace).join('|'), 'gi');
    return line.replace(regexPattern, function (template) {
        return replace[template] ?? template;
    });
};

/**
 *
 * Telescript is a solution what can help us displaying different messages for different customers (Georgia / Delaware / South Carolina ...). The imported components are exactly the same as code level, but because every customer has a different CMS endpoint, we can set custom text overrides. Please see adjecent README file for more details.
 */

const TeleScript = ({ line, replace = {}, children }) => {
    //* Replace template variables, like: %TEMPLATE_DATE%
    if (line && Object.keys(replace).length) {
        line = replaceAll(line, replace);
    }

    if (line) {
        return <div dangerouslySetInnerHTML={{ __html: line }} />;
    } else {
        return <>{children}</>;
    }
};

export default TeleScript;
